import urls from "../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../utils/service";

const base = urls.url_prod;

function qs(params: Record<string, string | number | undefined>) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === "") return;
    search.set(key, String(value));
  });
  const text = search.toString();
  return text ? `?${text}` : "";
}

export async function listCallDatasets(
  organizationId: string,
  opts?: { owned?: boolean }
) {
  const callParams = await getCallParams("GET");
  return makeCall(
    `${base}/call-datasets${qs({
      organizationId,
      owned: opts?.owned ? "1" : "",
    })}`,
    callParams
  );
}

export async function listCallDatasetRows(params: Record<string, string | number | undefined>) {
  const callParams = await getCallParams("GET");
  return makeCall(`${base}/call-datasets/rows${qs(params)}`, callParams);
}

export async function assignCallDatasetRows(body: Record<string, unknown>) {
  const callParams = await getCallParams("POST", body);
  return makeCall(`${base}/call-datasets/assign`, callParams);
}

export async function updateCallDatasetStage(id: string, stage: string) {
  const callParams = await getCallParams("POST", { id, stage });
  return makeCall(`${base}/call-datasets/stage`, callParams);
}

export async function convertCallDatasetRows(ids: string[]) {
  const callParams = await getCallParams("POST", { ids });
  return makeCall(`${base}/call-datasets/convert`, callParams);
}
